import {getAxios} from '@deviceinsight/ng-ui-api-client';

export type AggregatedFact = {
	aggregatedValue: number | null | undefined;
	rangeEnd: string;
	rangeStart: string;
};

export type AggregatedFacts = {
	aggregatedFacts: Array<AggregatedFact> | null | undefined;
};

type KpiQueryType = 'QUERY_SUM' | 'QUERY_AVERAGE' | 'QUERY_MAX' | 'QUERY_MIN' | 'QUERY_ALL';

export type KpiQueryAssetsBy = 'BY_ASSET_ID' | 'BY_SITE_GROUP_ID' | 'BY_ROBOT_SYSTEM_GROUP_ID';

export type KpiParams = {
	kpiName: string;
	queryAssetsBy: KpiQueryAssetsBy;
	queryAssetsById: number;
	queryType: KpiQueryType;
	daysOfWeek?: string;
	dateFrom: string;
	dateTo: string;
	tsFrom?: string;
	tsTo?: string;
	timeFrom?: string;
	timeTo?: string;
	userId?: number;
	externalUuid?: string | null | undefined;
	groupBy?: string;
};

export const getKpiGenericWithTimestamp = (params: KpiParams): Promise<AggregatedFacts> =>
	getAxios()
		.get('/rafi/v1/facts', {
			params: {...params}
		})
		.then(({data}) => data);

export const getKpiGeneric = (params: KpiParams): Promise<Array<number>> =>
	getAxios()
		.get('/rafi/v1/facts/generic', {
			params: {...params}
		})
		.then(({data}) => data);
